import { ReactNode } from "react"
import StrapiGallery from "@components/Strapi/Gallery"
import StrapiVideo from "@components/Strapi/Video"
import StrapiTwoColumns from "@components/Strapi/ContentTwoColumns"
import StrapiContentCard from "@components/Strapi/ContentCard"
// eslint-disable-next-line import/no-cycle
import RepeatableComponent from "@components/Strapi/RepeatableComponent"
import Sponsors from "./Sponsors"
import StrapiNewsletter from "./Newsletter"
import StrapiContentSlides from "./ContentSlides"
import StrapiHero from "./Hero"
import LatestNews from "./LatestNews"
import Content from "./Content"
import Positions from "./Positions"
import Spacer from "./Spacer"
import Faq from "./Faq"
import CardsThreeColumns from "./CardsThreeColumns"

const components: Record<string, ReactNode> = {
    StrapiComponentSectionsHero: StrapiHero,
    StrapiComponentSectionsNewsletter: StrapiNewsletter,
    StrapiComponentSectionsContentSlides: StrapiContentSlides,
    StrapiComponentSectionsLatestNews: LatestNews,
    StrapiComponentSectionsSponsors: Sponsors,
    StrapiComponentSectionsContent: Content,
    StrapiComponentSectionsPositions: Positions,
    StrapiComponentSectionsSpacer: Spacer,
    StrapiComponentSectionsFaq: Faq,
    StrapiComponentSectionsCardsThreeColumns: CardsThreeColumns,
    StrapiComponentSectionsGallery: StrapiGallery,
    StrapiComponentSectionsVideo: StrapiVideo,
    StrapiComponentSectionsContentTwoColumns: StrapiTwoColumns,
    StrapiComponentSectionsContentCard: StrapiContentCard,
    StrapiComponentSectionsRepeatableComponent: RepeatableComponent

}

export default components
